type StorageKind = "local" | "session";

// A context that withholds web storage fails in two different ways, and a guard
// for one does not cover the other: Safari with storage blocked throws a
// SecurityError from the `window.sessionStorage` property itself, while an
// Android WebView started with DOM storage disabled returns `null` from it, so
// the throw lands on `null.getItem` instead.
function resolveStorage(kind: StorageKind): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return (
      (kind === "local" ? window.localStorage : window.sessionStorage) ?? null
    );
  } catch {
    return null;
  }
}

export function readStorageItem(kind: StorageKind, key: string): string | null {
  const storage = resolveStorage(kind);
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorageItem(
  kind: StorageKind,
  key: string,
  value: string,
): void {
  const storage = resolveStorage(kind);
  if (!storage) return;
  try {
    storage.setItem(key, value);
  } catch {
    /* full or read-only store — every caller treats the write as advisory */
  }
}

export function removeStorageItem(kind: StorageKind, key: string): void {
  const storage = resolveStorage(kind);
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch {
    /* see writeStorageItem */
  }
}
